import { api, ApiError } from './api'
import type { ApiOptions } from './api'

export type AdminRequest = <T>(path: string, options?: ApiOptions) => Promise<T>

// Every admin call carries the shared token and treats a 401 as "the token is
// gone or was rotated" — the page re-prompts rather than leaving the operator
// staring at a dashboard that silently stopped working.
export function createAdminRequest(token: string, onUnauthorized: () => void): AdminRequest {
  return async <T,>(path: string, options: ApiOptions = {}): Promise<T> => {
    try {
      return await api<T>(path, { ...options, adminToken: token || undefined })
    } catch (error) {
      if (error instanceof ApiError && error.status === 401) onUnauthorized()
      throw error
    }
  }
}
